import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import { RfqService } from '@app/core/quotes';

@Component({
  selector: 'cnc-set-markup-structure',
  templateUrl: './set-markup-structure.component.html',
  styleUrls: ['./set-markup-structure.component.scss'],
})
export class SetMarkupStructureComponent implements OnInit {
  formData :UntypedFormGroup;
  pageTitle :string = 'Set Markup Structure';
  loading :boolean;
  submitted :boolean;

  @Input() rfq :any;

  constructor(
    private fb :UntypedFormBuilder,
    public activeModal :NgbActiveModal,
    private toastr :ToastrService,
    private cd :ChangeDetectorRef,
    public rfqService :RfqService,
  ) {}

  ngOnInit() {
    this.formData = this.fb.group({
      markup_structure: this.fb.array([]),
    });

    if (
      this.rfq &&
      this.rfq.markup_structure &&
      this.rfq.markup_structure.length > 0
    ) {
      this.rfq.markup_structure.forEach((ds :any) => {
        this.addRow(ds);
      });
    }
  }

  save() {
    this.submitted = true;
    if (this.formData.invalid) {
      Swal.fire({
        title: 'Form Error!',
        text: 'Please fill all the required fields.',
        type: 'error',
        confirmButtonText: 'Back to Form',
      });

      return;
    }

    this.loading = true;
    const payload :any = Object.assign({}, this.formData.value);

    this.rfqService.saveMarkupStructure(this.rfq.id, payload).subscribe(
      (resp :any) => {
        this.toastr.success('Markup structure set.', 'Success');
        this.activeModal.close(resp);
      },
      (errorResp) => {
        this.loading = false;
        Swal.fire(
          'Save error!',
          'Please try again later or contact support.',
          'error',
        );
      },
    );
  }

  addRow(item ?:any) {
    const itemRows :UntypedFormArray = this.formData.get(
      'markup_structure',
    ) as UntypedFormArray;
    itemRows.push(
      this.fb.group({
        label: [item ? item.label : '', Validators.required],
        min: [item ? item.min : 0, Validators.required],
        max: [item ? item.max : 0, Validators.required],
        discount: [item ? item.discount : 0, Validators.required],
      }),
    );
  }

  removeRow(idx :any) {
    const itemRows :UntypedFormArray = this.formData.get(
      'markup_structure',
    ) as UntypedFormArray;
    itemRows.removeAt(idx);
  }
}
